import { __read } from "tslib";
export function convertRatioToNumber(ratio) {
    var _a;
    if (typeof ratio === 'string') {
        var numerator = void 0;
        var denominator = void 0;
        try {
            _a = __read(ratio.split('-').map(function (n) { return parseInt(n, 10); }), 2), numerator = _a[0], denominator = _a[1];
        }
        catch (e) {
            if (process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.error("Unable to parse ".concat(ratio));
            }
            return 1;
        }
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn("Warning: AspectRatio expects a number. Replace <AspectRatio ratio={".concat(ratio, "}> with <AspectRatio ratio={").concat(numerator, " / ").concat(denominator, "}"));
        }
        return numerator / denominator;
    }
    return ratio;
}
